"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../Css");
function Loader({ size = "lg", contrast = false }) {
    const [dimensions, borderSize] = sizeToPixels[size];
    const [bgColor, spinnerColor] = contrast ? [Css_1.Palette.Gray600, Css_1.Palette.Gray200] : [Css_1.Palette.White, Css_1.Palette.Blue700];
    return ((0, jsx_runtime_1.jsx)("div", { "aria-label": "Loading", css: Css_1.Css.br100.ba
            .hPx(dimensions)
            .wPx(dimensions)
            .bc(bgColor)
            .bw(`${borderSize}px`)
            .add("borderTopColor", spinnerColor)
            .add("textIndent", "-999px")
            .add("animationName", "spin")
            .add("animationDuration", "800ms")
            .add("animationIterationCount", "infinite")
            .add("animationTimingFunction", "linear")
            .add("transform", "translateZ(0)").$ }));
}
exports.Loader = Loader;
const sizeToPixels = {
    xs: [16, 2],
    sm: [32, 4],
    md: [64, 8],
    lg: [96, 12],
};
